<template>
	<LeftSidebar :dark=true :toolbarColor="'grey darken-3'" :open="labelSidebarOpen" :width="320" :updateSidebar="updateLabelSidebar"
 		style="z-index: 41 !important;">
 		<div slot="sbTitle">
			Custom Labeling
    	</div> 
    	
    	<div slot="sbContent" class="pt-4 pr-4">
			<v-list class="pl-2">
	            <v-list-tile class="grey--text text--darken-2">
	            	<v-layout align-center>
	                <v-switch 
	                    :label="clVisible ? 'On' : 'Off'"
	                    v-model="clVisible"
	                ></v-switch>
	                <v-progress-circular
                            :size="30"
                            style="top: -15px;"
                            class=""
                            v-if="loading"
                            indeterminate
                            color="primary"
                        ></v-progress-circular> 
                    </v-layout>
	            </v-list-tile>       

	            <v-divider></v-divider>
	            <v-subheader class="mb-2">Labels</v-subheader>
	            <v-list-tile class="grey--text text--darken-2">
	                <v-switch 
	                    label="Room Number"
	                    v-model="clRoomNumber"
	                ></v-switch>
	            </v-list-tile>
	            <v-list-tile class="grey--text text--darken-2">
	                <v-switch 
	                    label="Area"
	                    v-model="clArea"
	                ></v-switch>
	            </v-list-tile>
	            <v-list-tile class="grey--text text--darken-2">
	                <v-switch 
	                    label="Room Name"
	                    v-model="clName"
	                ></v-switch>
	            </v-list-tile>
	            <v-list-tile class="grey--text text--darken-2">
	                <v-switch v-if="!clHybrid"
	                    label="Occupants"
	                    v-model="clOccupant"
	                ></v-switch>
	            </v-list-tile>
	            <v-list-tile class="grey--text text--darken-2">
	                <v-switch v-if="!clHybrid"
	                    label="Principal Investigators"
	                    v-model="clPI"
	                ></v-switch>
	            </v-list-tile>
	            <v-list-tile class="grey--text text--darken-2">
	                <v-switch
	                    label="Hybrid"
	                    v-model="clHybrid"
	                ></v-switch>
	            </v-list-tile>

	            <v-divider class="mt-4"></v-divider>
	            <v-subheader class="mb-2">Label Options</v-subheader>
	            
	            <v-list-tile class="grey--text text--darken-2">
	                <v-switch
	                    label="Text Halo"
	                    v-model="clHalo"
	                ></v-switch>
	            </v-list-tile>
	            <v-list-tile class="grey--text text--darken-2">
	            	<v-flex xs12>
		            	<v-slider class="clSlider pt-0"
			            v-model="clFontSize"
			            inverse-label
			            label="Font Size"
			            :max="18"
			            :min="4"
			            :thumb-label="true"
			          	></v-slider>
		          	</v-flex>
	            </v-list-tile>
	            


	            <v-list-tile v-if="clPI || clOccupant || clHybrid" 
	            	class="grey--text text--darken-2">
	           		<v-layout column class="">
	            	<v-flex xs10>		            	
		            	<v-slider class="clSlider"
			            v-model="limitX"
			            inverse-label
			            label="Name Length"
			            :max="20"
			            :min="5"
			            :thumb-label="true"
			            @input="changeLimit"
			          	></v-slider>
		          	</v-flex>
		          </v-layout>
	            </v-list-tile>

	            <v-list-tile v-if="clPI || clOccupant" class="mt-5 grey--text text--darken-2">
	                    <v-radio-group  
	                    	v-model="nameRadio.value" 
	                    	@change="changeNaming(nameRadio.value)">
					      <v-radio
					      	class="ml-3"
					        v-for="item in namingChoices"
					        :key="item.value"
					        :label="`${item.label}`"
					        :value="item.value"

					      ></v-radio>
					    </v-radio-group>
	           	</v-list-tile>
	           	<v-list-tile v-if="nameRadio.value == 'name'" class="grey--text text--darken-2 mt-4">
	                <v-switch 
	                    label="Full Name on Two Lines"
	                    v-model="clNameBreak"
	                ></v-switch>
	            </v-list-tile>
	           	<v-list-tile v-if="clPI || clOccupant" class="mt-5 mb-3 grey--text text--darken-2">
	           		<v-radio-group
	           				row  
	                    	v-model="wrapRadio.value" 
	                    	@change="changeWrap(wrapRadio.value)">
					      <v-radio
					        class=""
					        v-for="item in wrapChoices"
					        :key="item.value"
					        :label="`${item.label}`"
					        :value="item.value"

					      ></v-radio>
					    </v-radio-group>
	           	</v-list-tile>
	        </v-list>  		
    	</div>
	    
	</LeftSidebar>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import LeftSidebar from './LeftSidebar'

	  	let LabelSidebar = {

			data() {
		  		return  {	namingChoices: [  
		  										{ label: 'Last Name', value: 'nameLast'},	  									  			  									  
		  									  	{ label: 'First Name', value: 'nameFirst'}, 
		  									  	{ label: 'Full Name', value: 'name'},
		  								   ],
		  					nameRadio:        	{ label: 'Last Name', value: 'nameLast'},

		  					wrapChoices:   [  
		  										{ label: 'Wrap 1', value: 'wrap1'},
		  									  	{ label: 'Wrap 2', value: 'wrap2'},
		  								   ],
		  					wrapRadio:        	{ label: 'Wrap 1', value: 'wrap1'},
					  	}
		},

		mounted : function () {
		},

		components: { LeftSidebar },

		computed: {
			...mapState({
				labelSidebarOpen: state => state.ui.labelSidebarOpen,
				darkTheme: state => state.ui.darkTheme,
				stateclVisible: state => state.ui.clVisible,
				stateclFontSize: state => state.ui.clFontSize,
				stateclRoomNumber: state => state.ui.clRoomNumber,
				stateclArea: state => state.ui.clArea,
				stateclName: state => state.ui.clName,
				stateclPI: state => state.ui.clPI,
				stateclOccupant: state => state.ui.clOccupant,
				stateclHybrid: state => state.ui.clHybrid,
				stateclNaming: state => state.ui.clNaming,
				stateclWrap: state => state.ui.clWrap,	
				stateclNameBreak: state => state.ui.clNameBreak,
				stateclHalo: state => state.ui.clHalo,
				stateclLimitX: state => state.ui.clLimitX,
				stateclLimitY: state => state.ui.clLimitY,			
				loading: state => state.search.loading,
				applyLabels: state => state.mapFunctions.applyLabels,
				stateMap: state => state.mapFunctions.stateMap,

			}),
			
			clVisible: {
				get () { return this.stateclVisible },
				set (value) { 
					if (this.stateMap.getLevel() < 22 && !this.stateclVisible) {
						this.stateMap.setZoom(22)
					}
					this.setclVisible(!this.stateclVisible) 										
				}
			},

			clRoomNumber: {
				get () { return this.stateclRoomNumber },
				set (value) { this.setclRoomNumber(!this.stateclRoomNumber) }
			},

			clArea: {
				get () { return this.stateclArea },
				set (value) { this.setclArea(!this.stateclArea) }
			},

			clName: {
				get () { return this.stateclName },
				set (value) { this.setclName(!this.stateclName) }
			},

			clPI: {
				get () { return this.stateclPI },
				set (value) { this.setclPI(!this.stateclPI) }
			},

			clOccupant: {
				get () { return this.stateclOccupant },
				set (value) { this.setclOccupant(!this.stateclOccupant) }
			},

			clHybrid: {
				get () { return this.stateclHybrid },
				set (value) { this.setclHybrid(!this.stateclHybrid) }
			},

			clNaming: {
				get () { return this.stateclNaming },
				set (value) { }
			},

			clWrap: {
				get () { return this.stateclWrap },
				set (value) { }
			},

			clNameBreak: {
				get () { return this.stateclNameBreak },
				set (value) { this.setclNameBreak(!this.stateclNameBreak) }
			},

			clHalo: {
				get () { return this.stateclHalo },
				set (value) { this.setclHalo(!this.stateclHalo) }
			},

			clFontSize: {
				get () { return this.stateclFontSize },
				set (value) { this.setclFontSize(value) }
			},

			limitX: {
				get () { return this.stateclLimitX },
				set (value) { this.setclLimitX(value) }
			},

			limitY: {
				get () { return this.stateclLimitY },
				set (value) { this.setclLimitY(value) }
			}

		},
		

		methods: {
		  	...mapMutations([	'updateLabelSidebar', 
		  						'setclVisible',
		  						'setclRoomNumber',
		  						'setclArea',
		  						'setclName',
		  						'setclPI',
		  						'setclOccupant',
		  						'setclHybrid',
		  						'setclNaming',
		  						'setclFontSize',
		  						'setclWrap',
		  						'setclNameBreak',
		  						'setclLimitX',
		  						'setclLimitY',
		  						'setclHalo',
		  					]),

		  	changeNaming: function (value) {
				this.setclNaming(value)
			},
			changeWrap: function (value) {
				this.setclWrap(value)
			},
			changeLimit: function (value) {
				//console.log("Changed Limit")
				this.applyLabels()
			},
		},			
						
	}
export default LabelSidebar
</script>


<style>

.clSlider.input-group.input-group--slider label {
	font-size: 12pt !important;
}



</style>





// WEBPACK FOOTER //
// src/components/LabelSidebar.vue